import {gameInfo} from './ReleasedGames';
import VideoSlot from './VideoSlot';

var selectedGameVideoList =[];
var genratedVideoList =[];

const CreateVideoList = function(props)
{
    return(
        <div className='videoTitleHolder'>
            <p>Videos Gallery</p>

            <div className='videoHolder'>               
               {CreateVideoSlides(props.num)}
            </div>
        </div>
    );
}
export default CreateVideoList;

function CreateVideoSlides(num)
{
  selectedGameVideoList = [];
  genratedVideoList = [];
  selectedGameVideoList = gameInfo[num].allVideoLinks;
  for (let i=0; i< selectedGameVideoList.length; i++)
  {
    if (selectedGameVideoList.length >2)
    {
        genratedVideoList[i] = <VideoSlot key = {'video_With_Class'+i} vlink ={selectedGameVideoList[i]} cla = {'vframe'} />
    }else
    {
        genratedVideoList[i] = <VideoSlot key = {'video_WithDiffrent_class'+i} vlink ={selectedGameVideoList[i]} cla = 'vDiffrentFrame' />
    }
  }
 
  console.log(genratedVideoList);
  return genratedVideoList;
}